export const MEMBERSHIP_RESET_STATE = 'MEMBERSHIP_RESET_STATE';
export const MEMBERSHIP_CURRENT_ITEM = 'MEMBERSHIP_CURRENT_ITEM';

export const MEMBERSHIP_REQUEST_LOADING = 'MEMBERSHIP_REQUEST_LOADING';
export const MEMBERSHIP_REQUEST_SUCCESS = 'MEMBERSHIP_REQUEST_SUCCESS';
export const MEMBERSHIP_REQUEST_FAILED = 'MEMBERSHIP_REQUEST_FAILED';

export const MEMBERSHIP_CURRENT_ACTION = 'MEMBERSHIP_CURRENT_ACTION';
export const MEMBERSHIP_RESET_ACTION = 'MEMBERSHIP_RESET_ACTION';